"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.list.title': 'Professions',
    'profession.list.empty': 'No professions found',
};
